import logo from './logo.svg';
import bootstrap from 'bootstrap'
import AOS from 'aos'
import 'aos/dist/aos.css'; // You can also use <link> for styles
import {CopyToClipboard} from 'react-copy-to-clipboard';

import SchutzraumDiGa from './images/Schutzraum-diGallo.png'

import './App.css';
  AOS.init({
    anchorPlacement: 'top-center',
    easing: 'easy',
  });

function App() {


  return (
    <div class="text-bg-light">
    <nav class="navbar bg-dark" data-bs-theme="dark">
    <div class="container">
      <a class="navbar-brand" href="#">di Gallo Branding</a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
    </div>
    </nav>
    {/*Header*/}
    <div class="position-relative overflow-hidden p-3 p-md-5 m-md-3 text-center bg-light">
      
    </div>


      <div className="container-fluid">
        <div className="row-wrapper row">
          <div class="col-md-2">
            <div className="sticky-top sticky-wrap">
              <ul class="list-group list-group-flush brand-nav scrollspy" id="nav">
                <li class="list-group-item"><a class="nav-link" scrollspy href="#brand-guidelines">Brand Guidelines</a></li>
                <li class="list-group-item"><a class="nav-link" scrollspy href="#logos">Logos</a></li>
                <li class="list-group-item"><a class="nav-link" href="#farben">Farben</a></li>
                <li class="list-group-item"><a class="nav-link" href="#typografie">Typografie</a></li>
                <li class="list-group-item"><a class="nav-link" href="#bildwelt">Bildwelt</a></li>
                <li class="list-group-item"><a class="nav-link" href="#sprache">Sprache</a></li>
                <li class="list-group-item"><a class="nav-link" href="#vorlagen">Vorlagen</a></li>
                <li class="list-group-item"><a class="nav-link" href="#beispiele">Beispiele</a></li>
              </ul>
            </div>
          </div>
          <div class="col-md-9 sticky-wrap" data-bs-spy="scroll" data-bs-target="#nav" data-bs-smooth-scroll="true">

            <section data-aos-duration="500" data-aos="fade-up" class="section-tools section-title">
              <div class="row" id="brand-guidelines">
                <div class="col-md-12">
                  <h3>Brand Guidelines</h3>
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                </div>
              </div>
            </section>

            <section data-aos-duration="500" data-aos="fade-up" class="section-tools section-title">
              <div class="row" id="logos">
                <div class="col-md-12">
                  <h3>Logos</h3>
                  <hr />
                  <div class="row">
                    <div class="col-md-6">
                      <h4>Schutzraum</h4>
                      <p>Hoihoi</p>
                    </div>
                    <div class="col-md-6">
                      <img class="img-fluid" src={SchutzraumDiGa} />
                    </div>
                  </div>
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                </div>
              </div>
            </section>

            <section data-aos-duration="500" data-aos-offset="100" data-aos="fade-up" class="section-tools section-title">
              <div class="row container-fluid" id="farben">
                <div class="col-md-12">
                  <h3>Farben</h3>
                  <p>Jedes Haus hat seine eigene, kleine Farbpalette. Ergänzt werden können die Farben jeweils mit «di Gallo Wolke» und «di Gallo </p>

                  <h4>di Gallo</h4>
                  
                  <div class="row">
                    <div class="col-md-3">
                      <div className="card">
                      <div class="card-img-top color" style={{backgroundColor: '#72A93E'}}> </div>
                      <ul class="list-group list-group-flush">
                      <li class="list-group-item"><h5 class="">di Gallo Wiese</h5></li>
                        <li class="list-group-item small"><strong>HEX &nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;</strong>#72A93E &nbsp;&nbsp;
                          <CopyToClipboard text="72A93E" onCopy="">
                            <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                          </CopyToClipboard>
                        </li>

                        <li class="list-group-item small"><strong>CMYK &nbsp;&nbsp;</strong>62 11 92 0 &nbsp;&nbsp;
                          <CopyToClipboard text="62 11 92 0" onCopy="">
                            <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                          </CopyToClipboard>
                        </li>
                  
                      </ul>
                      </div>
                    </div>
                  <div class="col-md-3">
                        <div class="card">
                          <div class="card-img-top color" style={{backgroundColor: '#FDC431'}}> </div>
                          <ul class="list-group list-group-flush">
                          <li class="list-group-item"><h5 class="">di Gallo Sonne</h5></li>
                            <li class="list-group-item small"><strong>HEX &nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;</strong>#FDC431 &nbsp;&nbsp;
                              <CopyToClipboard text="FDC431" onCopy="">
                                <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                              </CopyToClipboard>
                            </li>

                            <li class="list-group-item small"><strong>CMYK &nbsp;&nbsp;</strong>0 25 85 0 &nbsp;&nbsp;
                              <CopyToClipboard text="0 25 85 0" onCopy="">
                                <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                              </CopyToClipboard>
                            </li>
                      
                          </ul>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="card">
                          <div class="card-img-top color" style={{backgroundColor: '#F8F9FA'}}> </div>
                          <ul class="list-group list-group-flush">
                          <li class="list-group-item"><h5 class="">di Gallo Wolke</h5></li>
                            <li class="list-group-item small"><strong>HEX &nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;</strong>#F8F9FA &nbsp;&nbsp;
                              <CopyToClipboard text="F8F9FA" onCopy="">
                                <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                              </CopyToClipboard>
                            </li>

                            <li class="list-group-item small"><strong>CMYK &nbsp;&nbsp;</strong>0 25 85 0 &nbsp;&nbsp;
                              <CopyToClipboard text="0 25 85 0" onCopy="">
                                <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                              </CopyToClipboard>
                            </li>
                      
                          </ul>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="card">
                          <div class="card-img-top color" style={{backgroundColor: '#202136'}}> </div>
                          <ul class="list-group list-group-flush">
                          <li class="list-group-item"><h5 class="">di Gallo Nacht</h5></li>
                            <li class="list-group-item small"><strong>HEX &nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;</strong>#202136 &nbsp;&nbsp;
                              <CopyToClipboard text="202136" onCopy="">
                                <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                              </CopyToClipboard>
                            </li>

                            <li class="list-group-item small"><strong>CMYK &nbsp;&nbsp;</strong>41 39 0 79 &nbsp;&nbsp;
                              <CopyToClipboard text="0 25 85 0" onCopy="">
                                <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                              </CopyToClipboard>
                            </li>
                      
                          </ul>
                        </div>
                      </div>

                      

                    </div>

                  <hr />

                  <h4>Tabor</h4>
                  
                   <div class="row">
                      <div class="col-md-4">
                        <div class="card">
                        <div class="card-img-top color" style={{backgroundColor: '#409945'}}> </div>
                        <ul class="list-group list-group-flush">
                        <li class="list-group-item"><h5 class="">Tabor Primär</h5></li>
                          <li class="list-group-item small"><strong>RGB &nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;</strong>#409945 &nbsp;&nbsp;
                            <CopyToClipboard text="409945" onCopy="">
                              <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                            </CopyToClipboard>
                          </li>

                          <li class="list-group-item small"><strong>CMYK &nbsp;&nbsp;</strong>76 15 91 2 &nbsp;&nbsp;
                            <CopyToClipboard text="76 15 91 2" onCopy="">
                              <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                            </CopyToClipboard>
                          </li>
                        </ul>
                        </div>
                      </div>
                      

                      <div class="col-md-4">
                        <div class="card">
                          <div class="card-img-top color" style={{backgroundColor: '#ADD5AD'}}> </div>
                          <ul class="list-group list-group-flush">
                          <li class="list-group-item"><h5 class="">Tabor Sekundär</h5></li>
                            <li class="list-group-item small"><strong>RGB &nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;</strong>#ADD5AD &nbsp;&nbsp;
                              <CopyToClipboard text="ADD5AD" onCopy="">
                                <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                              </CopyToClipboard>
                            </li>

                            <li class="list-group-item small"><strong>CMYK &nbsp;&nbsp;</strong>0 0 0 0 &nbsp;&nbsp;
                              <CopyToClipboard text="0 0 0 0" onCopy="">
                                <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                              </CopyToClipboard>
                            </li>
                      
                          </ul>
                        </div>
                      </div>
                    </div>
                    <hr />


                    <h4>Kreuzstift &nbsp;&nbsp;<button class="btn btn-outline-secondary btn-sm">Download</button></h4> 

                  
                   <div class="row">
                      <div class="col-md-4">
                        <div class="card">
                        <div class="card-img-top color" style={{backgroundColor: '#733A8E'}}> </div>
                        <ul class="list-group list-group-flush">
                        <li class="list-group-item"><h5 class="">Kreuzstift Primär</h5></li>
                          <li class="list-group-item small"><strong>RGB &nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;</strong>#733A8E &nbsp;&nbsp;
                            <CopyToClipboard text="733A8E" onCopy="">
                              <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                            </CopyToClipboard>
                          </li>

                          <li class="list-group-item small"><strong>CMYK &nbsp;&nbsp;</strong>0 0 0 0 &nbsp;&nbsp;
                            <CopyToClipboard text="0 0 0 0" onCopy="">
                              <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                            </CopyToClipboard>
                          </li>
                        </ul>
                        </div>
                      </div>
                      

                      <div class="col-md-4">
                        <div class="card">
                          <div class="card-img-top color" style={{backgroundColor: '#CA9EC9'}}> </div>
                          <ul class="list-group list-group-flush">
                          <li class="list-group-item"><h5 class="">Kreuzstift Sekundär</h5></li>
                            <li class="list-group-item small"><strong>RGB &nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;</strong>#CA9EC9 &nbsp;&nbsp;
                              <CopyToClipboard text="CA9EC9" onCopy="">
                                <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                              </CopyToClipboard>
                            </li>

                            <li class="list-group-item small"><strong>CMYK &nbsp;&nbsp;</strong>0 0 0 0 &nbsp;&nbsp;
                              <CopyToClipboard text="0 0 0 0" onCopy="">
                                <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                              </CopyToClipboard>
                            </li>
                      
                          </ul>
                        </div>
                      </div>
                    </div>
                    <hr />


                    <h4>Brunisberg</h4>

                   <div class="row">
                      <div class="col-md-4">
                        <div class="card">
                        <div class="card-img-top color" style={{backgroundColor: '#307CC0'}}> </div>
                        <ul class="list-group list-group-flush">
                        <li class="list-group-item"><h5 class="">Brunisberg Primär</h5></li>
                          <li class="list-group-item small"><strong>RGB &nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;</strong>#307CC0 &nbsp;&nbsp;
                            <CopyToClipboard text="307CC0" onCopy="">
                              <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                            </CopyToClipboard>
                          </li>

                          <li class="list-group-item small"><strong>CMYK &nbsp;&nbsp;</strong>0 0 0 0 &nbsp;&nbsp;
                            <CopyToClipboard text="0 0 0 0" onCopy="">
                              <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                            </CopyToClipboard>
                          </li>
                        </ul>
                        </div>
                      </div>
                      

                      <div class="col-md-4">
                        <div class="card">
                          <div class="card-img-top color" style={{backgroundColor: '#9DCEF0'}}> </div>
                          <ul class="list-group list-group-flush">
                          <li class="list-group-item"><h5 class="">Brunisberg Sekundär</h5></li>
                            <li class="list-group-item small"><strong>RGB &nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;</strong>#9DCEF0 &nbsp;&nbsp;
                              <CopyToClipboard text="9DCEF0" onCopy="">
                                <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                              </CopyToClipboard>
                            </li>

                            <li class="list-group-item small"><strong>CMYK &nbsp;&nbsp;</strong>48 0 53 0 &nbsp;&nbsp;
                              <CopyToClipboard text="48 0 53 0" onCopy="">
                                <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                              </CopyToClipboard>
                            </li>
                      
                          </ul>
                        </div>
                      </div>
                    </div>
                    <hr />

                    <h4>Rosengarten</h4>

                  
                   <div class="row">
                      <div class="col-md-4">
                        <div class="card">
                        <div class="card-img-top color" style={{backgroundColor: '#D83634'}}> </div>
                        <ul class="list-group list-group-flush">
                        <li class="list-group-item"><h5 class="">Rosengarten Primär</h5></li>
                          <li class="list-group-item small"><strong>RGB &nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;</strong>#D83634 &nbsp;&nbsp;
                            <CopyToClipboard text="D83634" onCopy="">
                              <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                            </CopyToClipboard>
                          </li>

                          <li class="list-group-item small"><strong>CMYK &nbsp;&nbsp;</strong>0 0 0 0 &nbsp;&nbsp;
                            <CopyToClipboard text="0 0 0 0" onCopy="">
                              <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                            </CopyToClipboard>
                          </li>
                        </ul>
                        </div>
                      </div>
                      

                      <div class="col-md-4">
                        <div class="card">
                          <div class="card-img-top color" style={{backgroundColor: '#F0A4A4'}}> </div>
                          <ul class="list-group list-group-flush">
                          <li class="list-group-item"><h5 class="">Rosengarten Sekundär</h5></li>
                            <li class="list-group-item small"><strong>RGB &nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;</strong>#E97E7E &nbsp;&nbsp;
                              <CopyToClipboard text="E97E7E" onCopy="">
                                <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                              </CopyToClipboard>
                            </li>

                            <li class="list-group-item small"><strong>CMYK &nbsp;&nbsp;</strong>0 0 0 0 &nbsp;&nbsp;
                              <CopyToClipboard text="0 0 0 0" onCopy="">
                                <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                              </CopyToClipboard>
                            </li>
                      
                          </ul>
                        </div>
                      </div>
                    </div>
                    <hr />


                    <h4>Zumipark</h4>
                  
                   <div class="row">
                      <div class="col-md-4">
                        <div class="card">
                        <div class="card-img-top color" style={{backgroundColor: '#617E8B'}}> </div>
                        <ul class="list-group list-group-flush">
                        <li class="list-group-item"><h5 class="">Zumipark Primär</h5></li>
                          <li class="list-group-item small"><strong>RGB &nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;</strong>#617E8B &nbsp;&nbsp;
                            <CopyToClipboard text="617E8B" onCopy="">
                              <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                            </CopyToClipboard>
                          </li>

                          <li class="list-group-item small"><strong>CMYK &nbsp;&nbsp;</strong>0 0 0 0 &nbsp;&nbsp;
                            <CopyToClipboard text="0 0 0 0" onCopy="">
                              <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                            </CopyToClipboard>
                          </li>
                        </ul>
                        </div>
                      </div>
                      

                      <div class="col-md-4">
                        <div class="card">
                          <div class="card-img-top color" style={{backgroundColor: '#90A4AC'}}> </div>
                          <ul class="list-group list-group-flush">
                          <li class="list-group-item"><h5 class="">Zumipark Sekundär</h5></li>
                            <li class="list-group-item small"><strong>RGB &nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;</strong>#90A4AC &nbsp;&nbsp;
                              <CopyToClipboard text="90A4AC" onCopy="">
                                <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                              </CopyToClipboard>
                            </li>

                            <li class="list-group-item small"><strong>CMYK &nbsp;&nbsp;</strong>0 0 0 0 &nbsp;&nbsp;
                              <CopyToClipboard text="0 0 0 0" onCopy="">
                                <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                              </CopyToClipboard>
                            </li>
                      
                          </ul>
                        </div>
                      </div>
                    </div>
                    <hr />


                     <h4>Wäckerling</h4>
                  
                   <div class="row">
                      <div class="col-md-4">
                        <div class="card">
                        <div class="card-img-top color" style={{backgroundColor: '#F7A810'}}> </div>
                        <ul class="list-group list-group-flush">
                        <li class="list-group-item"><h5 class="">Wäckerling Primär</h5></li>
                          <li class="list-group-item small"><strong>RGB &nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;</strong>#F7A810 &nbsp;&nbsp;
                            <CopyToClipboard text="F7A810" onCopy="">
                              <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                            </CopyToClipboard>
                          </li>

                          <li class="list-group-item small"><strong>CMYK &nbsp;&nbsp;</strong>0 0 0 0 &nbsp;&nbsp;
                            <CopyToClipboard text="0 0 0 0" onCopy="">
                              <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                            </CopyToClipboard>
                          </li>
                        </ul>
                        </div>
                      </div>
                      

                      <div class="col-md-4">
                        <div class="card">
                          <div class="card-img-top color" style={{backgroundColor: '#F9E893'}}> </div>
                          <ul class="list-group list-group-flush">
                          <li class="list-group-item"><h5 class="">Wäckerling Sekundär</h5></li>
                            <li class="list-group-item small"><strong>RGB &nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;</strong>#F9E893 &nbsp;&nbsp;
                              <CopyToClipboard text="F9E893" onCopy="">
                                <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                              </CopyToClipboard>
                            </li>

                            <li class="list-group-item small"><strong>CMYK &nbsp;&nbsp;</strong>0 0 0 0 &nbsp;&nbsp;
                              <CopyToClipboard text="0 0 0 0" onCopy="">
                                <button type="button" class="btn badge rounded-pill text-bg-light">Copy</button>
                              </CopyToClipboard>
                            </li>
                      
                          </ul>
                        </div>
                      </div>
                    </div>

                </div>
              </div>
            </section>

            <section data-aos-duration="500" data-aos="fade-up" class="section-tools section-title">
              <div class="row" id="typografie">
                <div class="col-md-12">
                  <h3>Typografie</h3>
                  <p>Die Hausschrift der di Gallo Gruppe ist «di Gallo Inter». <br />Die Schrift basiert auf der Open Source Schrift <a href="https://rsms.me/inter/" target="_blank">«Inter» von Rasmus Andersson</a>.</p>
                  
                  <button class="btn btn-outline-secondary">Download Font</button>
                  <br /><br />

                  <div class="row">
                  <hr />
                    <div class="col-md-6">
                      <h5 class="small">di Gallo Inter Light</h5>
                      <p class="fs-1" style={{fontWeight: 300}}>Kompetenz & <br />Menschlichkeit</p>
                    </div>
                    <div class="col-md-6">
                      <h5 class="small">di Gallo Inter Light Italic</h5>
                      <p class="fs-1" style={{fontWeight: 300, fontStyle: 'Italic'}}>Kompetenz & <br />Menschlichkeit</p>
                    </div>
                    <hr />
                    <div class="col-md-6">
                      <h5 class="small">di Gallo Inter Regular</h5>
                      <p class="fs-1" style={{fontWeight: 500}}>Kompetenz & <br />Menschlichkeit</p>
                    </div>
                    <div class="col-md-6">
                      <h5 class="small">di Gallo Inter Regular Italic</h5>
                      <p class="fs-1" style={{fontWeight: 500, fontStyle: 'Italic'}}>Kompetenz & <br />Menschlichkeit</p>
                    </div>
                    <hr />
                    <div class="col-md-6">
                      <h5 class="small">di Gallo Inter Medium</h5>
                      <p class="fs-1" style={{fontWeight: 600}}>Kompetenz & <br />Menschlichkeit</p>
                    </div>
                    <div class="col-md-6">
                      <h5 class="small">di Gallo Inter Medium Italic</h5>
                      <p class="fs-1" style={{fontWeight: 600, fontStyle: 'Italic'}}>Kompetenz & <br />Menschlichkeit</p>
                    </div>
                    <hr />
                    <div class="col-md-6">
                      <h5 class="small">di Gallo Inter Bold</h5>
                      <p class="fs-1" style={{fontWeight: 700}}>Kompetenz & <br />Menschlichkeit</p>
                    </div>
                    <div class="col-md-6">
                      <h5 class="small">di Gallo Inter Bold Italic</h5>
                      <p class="fs-1" style={{fontWeight: 700, fontStyle: 'Italic'}}>Kompetenz & <br />Menschlichkeit</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section data-aos-duration="500" data-aos="fade-up"  class="section-tools section-title">
              <div class="row" id="bildwelt">
                <div class="col-md-12">
                  <h3>Bildwelt</h3>
                  <p>Die Bildwelt der di Gallo Gruppe blabla</p>
                  <div class="spinner-grow text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            </section>

            <section data-aos-duration="500" data-aos="fade-up" class="section-tools section-title">
              <div class="row" id="sprache">
                <div class="col-md-12">
                  <h3>Sprache</h3>
                  <p>whoop whop</p>
                </div>
              </div>
            </section>

            <section data-aos-duration="500" data-aos="fade-up" class="section-tools section-title">
              <div class="row" id="vorlagen">
                <div class="col-md-12">
                  <h3>Vorlagen</h3>
                </div>
              </div>
            </section>

            <section data-aos-duration="500" data-aos="fade-up" class="section-tools section-title">
              <div class="row" id="beispiele">
                <div class="col-md-12">
                  <h3>Beispiele</h3>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
